export default __webpack_public_path__ + "static/media/cancelArrow.08fa22b2.svg";